import { Form } from "./Form";
import { Container } from "./StartConversationWithNote.styles";

export const StartConversationWithNote = () => {
    return (
        <Container.Outer>
            <Container.Inner>
                <Form />
            </Container.Inner>
        </Container.Outer>
    );
};
